export default __webpack_public_path__ + "static/media/ic-arrow-down.dc90f092.svg";